module.exports = __webpack_public_path__ + "static/img/slide-1.be4a904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-1.jpg
// module id = Xt0I
// module chunks = 1